import type { SVGProps } from 'react';
import { IconBase } from './icon-base';

export function BoldIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M14 12a4 4 0 0 0 0-8H6v8" />
      <path d="M15 20a4 4 0 0 0 0-8H6v8Z" />
    </IconBase>
  );
}
